var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    [
      _vm.text.subtitle
        ? _c("BaseCaption", {
            staticClass: "terms__caption",
            attrs: { text: _vm.text.subtitle, tag: "h3" }
          })
        : _vm._e(),
      _vm._l(_vm.text.items, function(textItem, index) {
        return _c("BaseText", {
          key: index,
          staticClass: "terms__descr",
          attrs: { text: textItem }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-307aafbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-307aafbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/TermsTextItem.vue
// module id = dvAv
// module chunks = 7